import React from "react";
import AddIcon from "icons/AddIcon.js";
import LogoutButton from "../auth/LogoutButton.js";

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.handleHeaderKeyDown = this.handleHeaderKeyDown.bind(this);
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleHeaderKeyDown);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.canEnterItem !== this.props.canEnterItem) {
      if (this.props.canEnterItem) {
        window.addEventListener("keydown", this.handleHeaderKeyDown);
      } else {
        window.removeEventListener("keydown", this.handleHeaderKeyDown);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleHeaderKeyDown);
  }

  handleHeaderKeyDown(e) {
    if (e.key === "Enter") {
      if (this.props.canEnterItem) {
        this.props.handleNewTaskButtonClick();
      }
    }
  }

  render() {
    const { handleNewTaskButtonClick, canEnterItem } = this.props;
    return (
      <header className="App-header">
        <div className="icons-container">
          {this.props.isLoggedIn && (
            <LogoutButton
              resetAppState={this.props.resetAppState}
              setIsLoggedIn={this.props.setIsLoggedIn}
            />
          )}
        </div>
        <span id="site-title">Glass Planner</span>
        <div className="icons-container">
          <button
            onClick={handleNewTaskButtonClick}
            disabled={!canEnterItem}
            className="add-task-button"
          >
            <AddIcon className="add-icon" />
          </button>
        </div>
      </header>
    );
  }
}
